import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootPrintPortalManager.frontend.types'
import { $frontendTypes as $types} from './FootPrintPortalManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { Materials_packages_excl_materials_dd_singleComponent } from './Materials.packages_excl_materials_dd_single.component'
import { Materials_material_packagings_dd_singleComponent } from './Materials.material_packagings_dd_single.component'
import { Materials_decimal_precision_singleComponent } from './Materials.decimal_precision_single.component'
import { Materials_measurement_units_dd_singleComponent } from './Materials.measurement_units_dd_single.component'


interface IFootPrintPortalManager_material_packagings_gridComponentEntity {
MaterialId?: number, PackagingId?: number, AutogenerateSerialNumbers?: boolean, DimensionUomId?: number, Height?: number, IsOrderDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, SubPackagingQuantity?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, ShortName?: string }, DimensionsUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Id?: number, Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }, SubPackaging?: { Id?: number, ShortName?: string }, Material?: { Id?: number, IsFinishedGood?: boolean, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean }}

interface IFootPrintPortalManager_material_packagings_gridComponentInParams {
  materialId?: number}


class FootPrintPortalManager_material_packagings_gridComponentRowModel extends GridRowModel {
  grid: FootPrintPortalManager_material_packagings_gridComponent;
  entity: IFootPrintPortalManager_material_packagings_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    packaging_short_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    sub_packaging_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    sub_uom_quantity_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    default_packaging_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    default_packaging_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    decimal_precision_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    upc_code_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    length_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    width_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    dimension_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    volume_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_high_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_tie_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    ready_to_ship_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    ready_to_ship_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    autogenerate_serial_numbers_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    autogenerate_serial_numbers_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    packaging_short_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['packaging_short_name_edit'] as DatexFormControl, 
        null, null,
        false, 
        '', null)
      ),
    sub_packaging: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['sub_packaging_edit'] as DatexFormControl, 
        null, null,
        false, 
        '', null)
      ),
    sub_uom_quantity: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null,  'number', '0', null)
,
      new NumberBoxModel(this.formGroup.controls['sub_uom_quantity_edit'] as DatexFormControl, null, false, '0', '', null)
      ),
    default_packaging: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['default_packaging_display'] as DatexFormControl, null, true, '', null)
,
      new CheckBoxModel(this.formGroup.controls['default_packaging_edit'] as DatexFormControl, null, false, '', null)
      ),
    decimal_precision: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['decimal_precision_edit'] as DatexFormControl, 
        null, null,
        false, 
        '', null)
      ),
    upc_code: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['upc_code_edit'] as DatexFormControl, null, false, '', null)
      ),
    length: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['length_edit'] as DatexFormControl, null, false, '0.00', '', null)
      ),
    width: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['width_edit'] as DatexFormControl, null, false, '0.00', '', null)
      ),
    height: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['height_edit'] as DatexFormControl, null, false, '0.00', '', null)
      ),
    dimension_uom: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['dimension_uom_edit'] as DatexFormControl, 
        null, null,
        false, 
        '', null)
      ),
    weight: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['weight_edit'] as DatexFormControl, null, false, '0.00', '', null)
      ),
    shipping_weight: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_weight_edit'] as DatexFormControl, null, false, '0.00', '', null)
      ),
    weight_uom: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['weight_uom_edit'] as DatexFormControl, 
        null, null,
        false, 
        '', null)
      ),
    volume: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['volume_edit'] as DatexFormControl, null, false, '0.00', '', null)
      ),
    shipping_volume: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_volume_edit'] as DatexFormControl, null, false, '0.00', '', null)
      ),
    volume_uom: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['volume_uom_edit'] as DatexFormControl, 
        null, null,
        false, 
        '', null)
      ),
    pallet_high: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_high_edit'] as DatexFormControl, null, false, '0', '', null)
      ),
    pallet_tie: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_tie_edit'] as DatexFormControl, null, false, '0', '', null)
      ),
    ready_to_ship: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['ready_to_ship_display'] as DatexFormControl, null, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['ready_to_ship_edit'] as DatexFormControl, null, false, '', null)
      ),
    autogenerate_serial_numbers: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['autogenerate_serial_numbers_display'] as DatexFormControl, null, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['autogenerate_serial_numbers_edit'] as DatexFormControl, null, false, '', null)
      ),
  }

  get $fields_packaging_short_name_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = $grid.inParams.materialId;
    
    return expr;
  }
  get $fields_sub_packaging_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = $grid.inParams.materialId;
    
    return expr;
  }
  get $fields_dimension_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_weight_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = 3;
    
    return expr;
  }
  get $fields_volume_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.utils;
    const $grid = this.grid;
    const expr = 2;
    
    return expr;
  }


  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
private logger: CleanupLoggerService,
) {
    super();
    
  }

  async $initializeExisting(grid: FootPrintPortalManager_material_packagings_gridComponent, entity: IFootPrintPortalManager_material_packagings_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: FootPrintPortalManager_material_packagings_gridComponent, entity?: IFootPrintPortalManager_material_packagings_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_new_row();
    }

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = {};
    set($resultKey, 'MaterialId',this.entity.MaterialId);
    set($resultKey, 'PackagingId',this.entity.PackagingId);
    const inParams = {
      $keys:[$resultKey],
      materialId:  $grid.inParams.materialId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.datasources.Materials.ds_material_packagings_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.packaging_short_name.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.packaging_short_name.editControl as SelectBoxModel).reset($row.entity.PackagingId);
    (this.cells.sub_packaging.displayControl as TextModel).text = $row.entity.SubPackaging?.ShortName;
    (this.cells.sub_packaging.editControl as SelectBoxModel).reset($row.entity.SubPackaging?.Id);
    (this.cells.sub_uom_quantity.displayControl as TextModel).text = $row.entity.SubPackagingQuantity?.toString();
    (this.cells.sub_uom_quantity.editControl as NumberBoxModel).reset($row.entity.SubPackagingQuantity);
    (this.cells.default_packaging.displayControl as CheckBoxModel).reset($row.entity.IsOrderDefault);
    (this.cells.default_packaging.editControl as CheckBoxModel).reset($row.entity.IsOrderDefault);
    (this.cells.decimal_precision.editControl as SelectBoxModel).reset($row.entity.QuantityPrecisionScale);
    (this.cells.upc_code.displayControl as TextModel).text = $row.entity.UpcCode;
    (this.cells.upc_code.editControl as TextBoxModel).reset($row.entity.UpcCode);
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.length.editControl as NumberBoxModel).reset($row.entity.Length);
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.width.editControl as NumberBoxModel).reset($row.entity.Width);
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.height.editControl as NumberBoxModel).reset($row.entity.Height);
    (this.cells.dimension_uom.displayControl as TextModel).text = $row.entity.DimensionsUom?.Short_name;
    (this.cells.dimension_uom.editControl as SelectBoxModel).reset($row.entity.DimensionUomId);
    (this.cells.weight.displayControl as TextModel).text = $row.entity.Weight?.toString();
    (this.cells.weight.editControl as NumberBoxModel).reset($row.entity.Weight);
    (this.cells.shipping_weight.displayControl as TextModel).text = $row.entity.ShippingWeight?.toString();
    (this.cells.shipping_weight.editControl as NumberBoxModel).reset($row.entity.ShippingWeight);
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.weight_uom.editControl as SelectBoxModel).reset($row.entity.WeightUomId);
    (this.cells.volume.displayControl as TextModel).text = $row.entity.Volume?.toString();
    (this.cells.volume.editControl as NumberBoxModel).reset($row.entity.Volume);
    (this.cells.shipping_volume.displayControl as TextModel).text = $row.entity.ShippingVolume?.toString();
    (this.cells.shipping_volume.editControl as NumberBoxModel).reset($row.entity.ShippingVolume);
    (this.cells.volume_uom.displayControl as TextModel).text = $row.entity.VolumeUom?.Short_name;
    (this.cells.volume_uom.editControl as SelectBoxModel).reset($row.entity.VolumeUomId);
    (this.cells.pallet_high.displayControl as TextModel).text = $row.entity.PalletHigh?.toString();
    (this.cells.pallet_high.editControl as NumberBoxModel).reset($row.entity.PalletHigh);
    (this.cells.pallet_tie.displayControl as TextModel).text = $row.entity.PalletTie?.toString();
    (this.cells.pallet_tie.editControl as NumberBoxModel).reset($row.entity.PalletTie);
    (this.cells.ready_to_ship.displayControl as CheckBoxModel).reset($row.entity?.UseAsShippingContainer);
    (this.cells.ready_to_ship.editControl as CheckBoxModel).reset($row.entity?.UseAsShippingContainer);
    (this.cells.autogenerate_serial_numbers.displayControl as CheckBoxModel).reset($row.entity.AutogenerateSerialNumbers);
    (this.cells.autogenerate_serial_numbers.editControl as CheckBoxModel).reset($row.entity.AutogenerateSerialNumbers);

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootPrintPortalManager_material_packagings_gridComponentRowModel,
  $grid: FootPrintPortalManager_material_packagings_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  let payloadpackaging: any = {};
  
  
  if ($row.cells.length?.editControl.isChanged) {
      payloadpackaging.Length = $row.cells.length?.editControl.value;
  }
  if ($row.cells.width?.editControl.isChanged) {
      payloadpackaging.Width = $row.cells.width?.editControl.value;
  }
  if ($row.cells.height?.editControl.isChanged) {
      payloadpackaging.Height = $row.cells.height?.editControl.value;
  }
  if ($row.cells.dimension_uom?.editControl.isChanged) {
      payloadpackaging.DimensionUomId = $row.cells.dimension_uom?.editControl.value;
  }
  if ($row.cells.weight?.editControl.isChanged) {
      if ($row.entity.Material.IsFixedWeight && $row.cells.weight?.editControl.value <= 0) {
          await $shell.Materials.openErrorDialog(`Error on save`, `Weight must be greater than 0 for fixed weight materials`);
          throw new Error(`Weight must be greater than 0 for fixed weight materials`);
      } else {
          payloadpackaging.Weight = $row.cells.weight?.editControl.value;
      }
  }
  if ($row.cells.shipping_weight?.editControl.isChanged) {
      if ($row.entity.Material.IsFixedWeight && $row.cells.shipping_weight?.editControl.value < $row.cells.weight?.editControl.value) {
          await $shell.Materials.openErrorDialog(`Error on save`, `Shipping weight must be equal to or greater than the weight`);
          throw new Error(`Shipping weight must be equal to or greater than the weight`)
      } else {
          payloadpackaging.ShippingWeight = $row.cells.shipping_weight?.editControl.value;
      }
  }
  if ($row.cells.weight_uom?.editControl.isChanged) {
      payloadpackaging.WeightUomId = $row.cells.weight_uom?.editControl.value;
  }
  if ($row.cells.volume?.editControl.isChanged) {
      payloadpackaging.Volume = $row.cells.volume?.editControl.value;
  }
  if ($row.cells.shipping_volume?.editControl.isChanged) {
      if ($row.cells.shipping_volume?.editControl.value < $row.cells.volume?.editControl.value) {
          await $shell.Materials.openErrorDialog(`Error on save`, `Shipping volume must be equal to or greater than the volume`);
          throw new Error(`Shipping volume must be equal to or greater than the volume`)
      } else {
          payloadpackaging.ShippingVolume = $row.cells.shipping_volume?.editControl.value;
      }
  }
  if ($row.cells.volume_uom?.editControl.isChanged) {
      payloadpackaging.VolumeUomId = $row.cells.volume_uom?.editControl.value;
  }
  if ($row.cells.pallet_high?.editControl.isChanged) {
      payloadpackaging.PalletHigh = $row.cells.pallet_high?.editControl.value;
  }
  if ($row.cells.pallet_tie?.editControl.isChanged) {
      payloadpackaging.PalletTie = $row.cells.pallet_tie?.editControl.value;
  }
  if ($row.cells.upc_code?.editControl.isChanged) {
      payloadpackaging.UpcCode = $row.cells.upc_code?.editControl.value;
  }
  
  if ($row.cells.decimal_precision?.editControl.isChanged) {
      payloadpackaging.QuantityPrecisionScale = $row.cells.decimal_precision?.editControl.value;
  }
  
  if ($row.cells.default_packaging?.editControl.isChanged) {
      payloadpackaging.IsOrderDefault = $row.cells.default_packaging?.editControl.value;
  }
  
  if ($row.cells.ready_to_ship?.editControl.isChanged) {
      payloadpackaging.UseAsShippingContainer = $row.cells.ready_to_ship?.editControl.value;
  }
  
  if ($row.cells.autogenerate_serial_numbers?.editControl.isChanged) {
      payloadpackaging.AutogenerateSerialNumbers = $row.cells.autogenerate_serial_numbers?.editControl.value;
  }
  
  try {
  
      await $flows.Utilities.crud_update_dual_pk_flow({
          entitySet: 'MaterialsPackagingsLookup',
          entity: payloadpackaging,
          pk1String: 'MaterialId',
          pk1: $row.entity.MaterialId,
          pk2String: 'PackagingId',
          pk2: $row.entity.PackagingId
      })
  
      if ($row.cells.default_packaging?.editControl.isChanged) {
  
          const packagings = (await $datasources.Materials.ds_get_material_packagings_by_materialId.get({ materialId: $row.entity.MaterialId })).result;
          if ($utils.isDefined(packagings)) {
  
              for (let packaging of packagings) {
  
                  let packagingId = packaging.PackagingId
  
                  if (packagingId != $row.entity.PackagingId) {
  
                      let payloadpackaging: any = {};
                      payloadpackaging.IsOrderDefault = false;
  
                      await $flows.Utilities.crud_update_dual_pk_flow({
                          entitySet: 'MaterialsPackagingsLookup',
                          entity: payloadpackaging,
                          pk1String: 'MaterialId',
                          pk1: $row.entity.MaterialId,
                          pk2String: 'PackagingId',
                          pk2: packagingId
                      })
                  }
  
              }
  
  
          }
  
      }
  
  
      await $grid.refresh();
  
  }
  catch (error) {
      await $shell.Materials.showErrorDetails('Save', 'Error on save.', error);
      //$shell.Materials.openErrorDialog('Error on save', error.message);
      throw error; // to prevent displayMode 
  }
  
  
  
  
  
  }
  on_init_new_row(event = null) {
    return this.on_init_new_rowInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_new_rowInternal(
    $row: FootPrintPortalManager_material_packagings_gridComponentRowModel,
  $grid: FootPrintPortalManager_material_packagings_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const materialId = $grid.inParams.materialId
  
  
  $row.entity = {
      MaterialId: materialId
  };
  
  
  
  $row.cells.sub_uom_quantity.editControl.readOnly = false;
  $row.cells.packaging_short_name.editControl.readOnly = false;
  $row.cells.sub_packaging.editControl.readOnly = false;
  
  
  
  const material = (await $datasources.Materials.ds_get_material_by_materialId.get({ materialId: materialId })).result;
  if ($utils.isDefined(material)) {
  
      const materialControllerTypeId = material[0].ControllerTypeId;
      const materialIsFixedWeight = material[0].IsFixedWeight;
      const materialIsFixedLength = material[0].IsFixedLength;
      const materialIsFixedVolume = material[0].IsFixedVolume;
  
      // Serial controlled
      if (materialIsFixedWeight === false || materialControllerTypeId === 3 || materialControllerTypeId === 4 || materialIsFixedLength === false ||
          materialIsFixedVolume === false) {
          $row.cells.decimal_precision.editControl.readOnly = true;
  
      }
  
      else {
          $row.cells.decimal_precision.editControl.readOnly = false;
      }
  
  }
  
  }
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: FootPrintPortalManager_material_packagings_gridComponentRowModel,
  $grid: FootPrintPortalManager_material_packagings_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  var requiredFields: [control: string, display: string][];
  var missingRequiredFields: string[] = [];
  
  requiredFields = [
      [$row.cells.packaging_short_name.editControl.value, $grid.headers.packaging_short_name.name],
      [$row.cells.sub_packaging.editControl.value, $grid.headers.sub_packaging.name],
      [$row.cells.sub_uom_quantity.editControl.value, $grid.headers.sub_uom_quantity.name]
  ]
  
  for (let required of requiredFields) {
      if (!$utils.isDefined(required[0])) {
          missingRequiredFields.push(required[1])
      }
  }
  
  if (missingRequiredFields.length === 1) {
      $shell.Materials.openErrorDialog('Save', `Missing Required field: ${missingRequiredFields.join('\r\n').trim().toUpperCase()}`);
      throw new Error(`Missing Required field: ${missingRequiredFields.join('\r\n').trim().toUpperCase()}`); // to prevent displayMode 
  
  } else if (missingRequiredFields.length > 1) {
      $shell.Materials.openErrorDialog('Save', `Missing Required fields: ${missingRequiredFields.join(' & ').trim().toUpperCase()}`);
      throw new Error(`Missing Required fields: ${missingRequiredFields.join(' & ').trim().toUpperCase()}`); // to prevent displayMode 
  }
  
  const base = (await $datasources.Materials.ds_get_materials_basepackaging_by_materialId.get({ materialId: $grid.inParams.materialId })).result;
  if ($utils.isDefined(base)) {
  
      var basePackagingId = base.PackagingId
  }
  
  const subPackaging = (await $datasources.Materials.ds_get_material_packaging_by_materialId_and_packagingId.get({
      materialId: $grid.inParams.materialId,
      packagingId: $row.cells.sub_packaging.editControl.value
  })).result;
  
  if ($utils.isDefined(subPackaging)) {
      var basePackagingQty = subPackaging[0].BasePackagingQuantity * $row.cells.sub_uom_quantity.editControl.value
  }
  
  if (!$utils.isAllDefined(basePackagingId, basePackagingQty)) {
      $shell.Materials.openErrorDialog('Save', 'Cannot Calculate Base Packaging Data');
      throw new Error('Cannot Calculate Base Packaging Data'); // to prevent displayMode 
  }
  
  else {
  
      try {
  
  
  
          // Create material, globalmaterial and materialpackaginglookup
          const payloadMaterialPackaging = {
              "MaterialId": $grid.inParams.materialId,
              "PackagingId": $row.cells.packaging_short_name.editControl.value,
              "IsBasePackaging": false,
              "SubPackagingId": $row.cells.sub_packaging.editControl.value,
              "SubPackagingQuantity": $row.cells.sub_uom_quantity.editControl.value,
              "BasePackagingId": basePackagingId,
              "BasePackagingQuantity": basePackagingQty,
  
              "AllowFractions": true,
              "AllowInSalesOrder": true,
              "AllowInPurchaseOrder": true,
              "IsReportingDefault": false,
              "IsOrderDefault": $utils.isDefined($row.cells.default_packaging.editControl.value) ? $row.cells.default_packaging.editControl.value : false,
              "IsLabelCompliant": false,
              "UseAsShippingContainer": $utils.isDefined($row.cells.ready_to_ship.editControl.value) ? $row.cells.ready_to_ship.editControl.value : false,
              "DeprecatedPackaging": false,
              "AllowInMobileSales": false,
  
              "QuantityPrecisionScale": $utils.isDefined($row.cells.decimal_precision.editControl.value) ? $row.cells.decimal_precision.editControl.value : null,
  
              "ShippingWeight": $utils.isDefined($row.cells.shipping_weight.editControl.value) ? $row.cells.shipping_weight.editControl.value : 1,
              "Weight": $utils.isDefined($row.cells.weight.editControl.value) ? $row.cells.weight.editControl.value : 1,
              "TareWeight": 0,
              "WeightUomId": $utils.isDefined($row.cells.weight_uom.editControl.value) ? $row.cells.weight_uom.editControl.value : 14,
  
              "Height": $utils.isDefined($row.cells.height.editControl.value) ? $row.cells.height.editControl.value : 1,
              "Width": $utils.isDefined($row.cells.width.editControl.value) ? $row.cells.width.editControl.value : 1,
              "Length": $utils.isDefined($row.cells.length.editControl.value) ? $row.cells.length.editControl.value : 1,
              "DimensionUomId": $utils.isDefined($row.cells.dimension_uom.editControl.value) ? $row.cells.dimension_uom.editControl.value : 5,
  
              "Volume": $utils.isDefined($row.cells.volume.editControl.value) ? $row.cells.volume.editControl.value : 1,
              "ShippingVolume": $utils.isDefined($row.cells.shipping_volume.editControl.value) ? $row.cells.shipping_volume.editControl.value : 1,
              "VolumeUomId": $utils.isDefined($row.cells.volume_uom.editControl.value) ? $row.cells.volume_uom.editControl.value : 11,
  
              //  "StandardCost": 1,      // Removing cost and price as inventory adjustments are restricted based on allowed adjustment amounts.
              //  "StandardPrice": 1,
  
              "PalletTie": $row.cells.pallet_tie.editControl.value,
              "PalletHigh": $row.cells.pallet_high.editControl.value,
  
              "UpcCode": $row.cells.upc_code.editControl.value,
              "AutogenerateSerialNumbers": $row.cells.autogenerate_serial_numbers.editControl.value
  
          };
  
          await $flows.Utilities.crud_create_flow({ entitySet: 'MaterialsPackagingsLookup', entity: payloadMaterialPackaging });
  
          if ($row.cells.default_packaging.editControl.value) {
  
              const packagings = (await $datasources.Materials.ds_get_material_packagings_by_materialId.get({ materialId: $row.entity.MaterialId })).result;
              if ($utils.isDefined(packagings)) {
  
                  for (let packaging of packagings) {
  
                      let packagingId = packaging.PackagingId
  
                      if (packagingId != $row.cells.packaging_short_name.editControl.value) {
  
                          let payloadpackaging: any = {};
                          payloadpackaging.IsOrderDefault = false;
  
                          await $flows.Utilities.crud_update_dual_pk_flow({
                              entitySet: 'MaterialsPackagingsLookup',
                              entity: payloadpackaging,
                              pk1String: 'MaterialId',
                              pk1: $row.entity.MaterialId,
                              pk2String: 'PackagingId',
                              pk2: packagingId
                          })
                      }
  
                  }
  
  
              }
  
          }
  
  
  
          $grid.refresh();
  
      }
      catch (error) {
          $shell.Materials.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  }
  
  
  
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootPrintPortalManager_material_packagings_gridComponentRowModel,
  $grid: FootPrintPortalManager_material_packagings_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  var materialId = $row.entity.MaterialId;
  
  const material = (await $datasources.Materials.ds_get_material_by_materialId.get({ materialId: materialId })).result;
  if ($utils.isDefined(material)) {
  
      const materialControllerTypeId = material[0].ControllerTypeId;
      const materialIsFixedWeight = material[0].IsFixedWeight;
      const materialIsFixedLength = material[0].IsFixedLength;
      const materialIsFixedVolume = material[0].IsFixedVolume;
  
      // Serial controlled
      if (materialIsFixedWeight === false || materialControllerTypeId === 3 || materialControllerTypeId === 4 || materialIsFixedLength === false ||
          materialIsFixedVolume === false) {
          $row.cells.decimal_precision.editControl.readOnly = true;
  
      }
  
      else {
          $row.cells.decimal_precision.editControl.readOnly = false;
      }
  
  }
  
  
  
  
  if ($utils.isDefined($row.cells.packaging_short_name.displayControl.text)) {
      $row.cells.sub_uom_quantity.editControl.readOnly = true;
      $row.cells.packaging_short_name.editControl.readOnly = true;
      $row.cells.sub_packaging.editControl.readOnly = true;
  } else {
      $row.cells.sub_uom_quantity.editControl.readOnly = false;
      $row.cells.packaging_short_name.editControl.readOnly = false;
      $row.cells.sub_packaging.editControl.readOnly = false;
  }
  
  
  if ($utils.isDefined($row.entity.QuantityPrecisionScale)) {
  
      switch ($row.entity.QuantityPrecisionScale) {
  
          case 1: {
  
              $row.cells.decimal_precision.displayControl.text = '1 decimal place';
              break;
          }
          case 2: {
  
              $row.cells.decimal_precision.displayControl.text = '2 decimal places';
              break;
          }
          case 3: {
  
              $row.cells.decimal_precision.displayControl.text = '3 decimal places';
              break;
          }
          case 4: {
  
              $row.cells.decimal_precision.displayControl.text = '4 decimal places';
              break;
          }
          case 5: {
  
              $row.cells.decimal_precision.displayControl.text = '5 decimal places';
              break;
          }
          case 6: {
  
              $row.cells.decimal_precision.displayControl.text = '6 decimal places';
              break;
          }
          case 7: {
  
              $row.cells.decimal_precision.displayControl.text = '7 decimal places';
              break;
          }
          case 8: {
  
              $row.cells.decimal_precision.displayControl.text = '8 decimal places';
              break;
          }
  
  
  
      }
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Materials_packages_excl_materials_dd_singleComponent),
    forwardRef(() => Materials_material_packagings_dd_singleComponent),
    forwardRef(() => Materials_decimal_precision_singleComponent),
    forwardRef(() => Materials_measurement_units_dd_singleComponent),
  ],
  selector: 'FootPrintPortalManager-material_packagings_grid',
  templateUrl: './FootPrintPortalManager.material_packagings_grid.component.html'
})
export class FootPrintPortalManager_material_packagings_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootPrintPortalManager_material_packagings_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootPrintPortalManager_material_packagings_gridComponentInParams = { materialId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     packaging_short_name: new GridHeaderModel(new HeaderStyles(null, null), 'Packaging', false, false, null),       sub_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'Sub-packaging', false, false, null),       sub_uom_quantity: new GridHeaderModel(new HeaderStyles(null, null), 'Sub-packaging quantity', false, false, null),       default_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'Default', false, false, null),       decimal_precision: new GridHeaderModel(new HeaderStyles(null, null), 'Decimal precision', false, false, null),       upc_code: new GridHeaderModel(new HeaderStyles(null, null), 'UPC', false, false, null),       length: new GridHeaderModel(new HeaderStyles(null, null), 'Length', false, false, null),       width: new GridHeaderModel(new HeaderStyles(null, null), 'Width', false, false, null),       height: new GridHeaderModel(new HeaderStyles(null, null), 'Height', false, false, null),       dimension_uom: new GridHeaderModel(new HeaderStyles(null, null), 'UOM', false, false, null),       weight: new GridHeaderModel(new HeaderStyles(null, null), 'Weight', false, false, null),       shipping_weight: new GridHeaderModel(new HeaderStyles(null, null), 'Shipping weight', false, false, null),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'UOM', false, false, null),       volume: new GridHeaderModel(new HeaderStyles(null, null), 'Volume', false, false, null),       shipping_volume: new GridHeaderModel(new HeaderStyles(null, null), 'Shipping volume', false, false, null),       volume_uom: new GridHeaderModel(new HeaderStyles(null, null), 'UOM', false, false, null),       pallet_high: new GridHeaderModel(new HeaderStyles(null, null), 'Pallet high', false, false, null),       pallet_tie: new GridHeaderModel(new HeaderStyles(null, null), 'Pallet tie', false, false, null),       ready_to_ship: new GridHeaderModel(new HeaderStyles(null, null), 'Shippable container', false, false, null),       autogenerate_serial_numbers: new GridHeaderModel(new HeaderStyles(null, null), 'Autogenerate serials', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootPrintPortalManager_material_packagings_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('materialId') set $inParams_materialId(value: any) {
    this.inParams['materialId'] = value;
  }
  get $inParams_materialId(): any {
    return this.inParams['materialId'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: FootPrintPortalManager_ShellService,
    private datasources: FootPrintPortalManager_DatasourceService,
    private flows: FootPrintPortalManager_FlowService,
    private reports: FootPrintPortalManager_ReportService,
    private localization: FootPrintPortalManager_LocalizationService,
    private operations: FootPrintPortalManager_OperationService,
    private logger: CleanupLoggerService,
    ) {
    super();
    this.title = 'Packagings';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;

    this.pageSize = 10;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      materialId:  $grid.inParams.materialId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
    const data = await this.datasources.Materials.ds_material_packagings_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootPrintPortalManager_material_packagings_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations,
          this.logger);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IFootPrintPortalManager_material_packagings_gridComponentEntity) {
    const row = new FootPrintPortalManager_material_packagings_gridComponentRowModel(
      this.utils,
      this.settings,
      this.shell, 
      this.datasources,
      this.flows,
      this.reports,
      this.localization,
      this.operations,
      this.logger);
    await row.$initializeNew(this, entity, this.$rowPropertyChangeCallback.bind(this));
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
